define('app/selcomm/filter/evaluate/selcomm-filter-evaluate-factory',["factory!Webworker"], function (webworker) {
	"use strict";
	return selcommFilterEvaulateFactory;
	function selcommFilterEvaulateFactory(array, filter) {
		var filterEvaluator = webworker.create(selcommFilterEvaulateFactoryWorker);
		return filterEvaluator.run.apply(filterEvaluator, arguments);
	}
	function selcommFilterEvaulateFactoryWorker(array, filter) {
		// selcomm-filter-evaluate-factory
		var sdcRecordSetFactory = sdcRecordSetFactoryFactory();
		var evaluators = {
			"NotFilter": NotFilterEvaluator,
			"AnyFilterGroup": AnyFilterEvaluator,
			"AllFilterGroup": AllFilterEvaluator,
			"BasicPropertyFilter": BasicPropertyFilterEvaluator,
			"BetweenPropertyFilter": BetweenPropertyFilterEvaluator,
			"KeywordPropertyFilter": KeywordPropertyFilterEvaluator,
			"InPropertyFilter": InPropertyFilterEvaluator,
			"ExistsFilter": ExistsFilterEvaluator
		};

		var groups = sdcRecordSetFactory.grouped(array);
		var records = groups.flatten();
		var filtered = groups.filter(evalFilter);
		var original = filtered.map(getOriginal);
		return original;
		function getOriginal(group) {
			return group.key;
		}
		function evalFilter(group) {
			for (var i = 0; i < group.length; i++) {
				if (evaluateFilter(filter, records, group[i])) {
					return true;
				}
			}
		}

		function getEvaluator(filter) {
			if (isObject(filter)) {
				// TODO: Add a proper type check here
				var filterType = String(filter.$type).replace(/[^.]+\./, "");
				return evaluators[filterType];
			}
			else {
				return function () {
					return true;
				}
			}
		}

		function evaluateFilter(filter, collection, context, target) {
			switch (arguments.length) {
				case 2:
					target = context = collection;
					collection = null;
					break;
				case 3:
					target = context;
					break;
			}
			return getEvaluator(filter).call(filter, collection, target, context);
		}
		function NotFilterEvaluator(collection, context, target) {
			return !evaluateFilter(this.Filter, collection, context, target);
		}
		function AnyFilterEvaluator(collection, context, target) {
			return this.Filters.reduce(or, false);
			function or(prev, curr) {
				return prev || evaluateFilter(curr, collection, context, target);
			}
		}
		function AllFilterEvaluator(collection, context, target) {
			return this.Filters.reduce(and, true);
			function and(prev, curr) {
				return prev && evaluateFilter(curr, collection, context, target);
			}
		}
		function BasicPropertyFilterEvaluator(collection, context, target) {
			var targetValue = getValue(target, this.PropertyName);
			var value = getFilterValue(context, this.Value);
			switch (this.CompareOperator) {
				case "Equals":
					return filterEquality(value, targetValue);
				case "GreaterThan":
					return targetValue > value;
				case "GreaterThanOrEquals":
					return targetValue >= value;
				case "LessThan":
					return targetValue < value;
				case "LessThanOrEquals":
					return targetValue <= value;
				case "NotEquals":
					return !filterEquality(value, targetValue);
				default:
					throw Error("Unknown operator: " + this.CompareOperator);
			}
		}
		function BetweenPropertyFilterEvaluator(collection, context, target) {
			var targetValue = getValue(target, this.PropertyName);
			return targetValue >= getFilterValue(context, this.StartValue) && targetValue <= getFilterValue(context, this.EndValue);
		}
		function KeywordPropertyFilterEvaluator(collection, context, target) {
			throw new Error("Not supported");
		}
		function InPropertyFilterEvaluator(collection, context, target) {
			var targetValue = getValue(target, this.PropertyName);
			return this.Values
				.map(getFilterValue.bind(this, context))
				.reduce(filterInIterator.bind(this, getValue(target, this.PropertyName)), false);
		}
		function ExistsFilterEvaluator(collection, context, target) {
			for (var i = 0; i < collection.length; i++) {
				if (evaluateFilter(this.Filter, collection, context, collection[i])) {
					return true;
				}
			}
			return false;
		}
		function filterEquality(x, y) {
			// TODO: Account for typed enums and stuff in here.
			// Intentional == here as it allows type coertion between strings and numbers which we need to emulate the database.
			return fixNulls(x) == fixNulls(y);
		}
		function getValue(target, path) {
			if (!path) {
				return target;
			}
			var pathParts = path.split(".");
			for (var i = 0; i < pathParts.length; i++) {
				if (!isObject(target)) {
					return;
				}
				else {
					target = target[pathParts[i]];
				}
			}
			return target;
		}
		function getFilterValue(context, value) {
			// TODO: Add a proper type check here
			if (isObject(value) && value.$type === "Filters.ThisReference") {
				return getValue(context, value.PropertyName);
			}
			else {
				return value;
			}
		}
		function isObject(value) {
			return value !== null && typeof value === "object";
		}
		function fixNulls(value) {
			return value !== null ? value : undefined;
		}
		function isDefined(value) {
			return typeof value !== 'undefined';
		}
		function sdcRecordSetFactoryFactory() {
			function sdcRecordSetFactory(chunked, obj) {
				if (obj && obj.$$isRecordSet) {
					return obj;
				}
				var retVal;
				if (Array.isArray(obj)) {
					if (chunked) {
						retVal = extend(map(obj, function (item) {
							return extend(sdcRecordSetFactory(false, item), {
								key: item
							});
						}), {
							flatten: function flatten() {
								return mapMany(this, function (records) {
									return records;
								});
							}
						});
					}
					else {
						retVal = mapMany(obj, sdcRecordSetFactory.bind(null, false));
					}
				}
				else if (isObject(obj)) {
					var allVariations = map(obj, sdcRecordSetFactory.bind(null, false));
					var baseFactory = makeBaseFactory(allVariations, obj);
					var variations = makeVariations(allVariations);
					var records = map(variations, function (ext) {
						return baseFactory(ext);
					});
					retVal = records.length ? records : [baseFactory()];
				}
				else {
					retVal = [obj];
				}
				retVal.$$isRecordSet = true;
				return retVal;
			}
			function makeVariations(variations) {
				var arr = [];
				var indicies = map(filter(variations, hasManyVariations), startingIndex);
				var keys = Object.keys(indicies);
				var first = keys[0];
				var last = keys[keys.length - 1];
				while (isValid()) {
					arr.push(map(indicies, function (i, key) {
						return variations[key][i];
					}));
					increment();
				}
				return arr;
				function isValid() {
					if (!keys.length) {
						return false;
					}
					for (var i = 0; i < keys.length; i++) {
						var key = keys[i];
						if (indicies[key] >= variations[key].length) {
							return false;
						}
					}
					return true;
				}
				function increment() {
					indicies[keys[0]]++;
					for (var i = 0; i < keys.length - 1; i++) {
						var key = keys[i];
						var nextKey = keys[i + 1];
						if (indicies[key] >= variations[key].length) {
							indicies[key] = 0;
							indicies[nextKey]++;
						}
					}
				}
			}
			function startingIndex() {
				return 0;
			}
			function makeBaseFactory(variations, originalObject) {
				var base = map(filter(variations, hasOneOrNoVariations), singleOrDefault);
				return function factory(src) {
					var newObj = extend(shallowCopy(base), src);
					return newObj;
				}
			}
			function singleOrDefault(arr) {
				switch (arr.length) {
					case 0:
						return;
					case 1:
						return arr[0];
					default:
						throw Error("More than one");
				}
			}
			function hasManyVariations(arr) {
				return arr.length > 1;
			}
			function hasOneOrNoVariations(arr) {
				return !hasManyVariations.apply(this, arguments);
			}
			function makeNew(value) {
				if (Array.isArray(value)) {
					return [];
				}
				else if (isObject(value)) {
					return Object.create(Object.getPrototypeOf(value));
				}
				else {
					return undefined;
				}
			}

			function isObject(value) {
				return value !== null && typeof value === "object";
			}
			function mapMany(value, fn) {
				var newObj;
				if (Array.isArray(value)) {
					return mapManyArr(value, fn);
				}
				else {
					return mapManyObj(value, fn);
				}
			}

			function mapManyArr(arr, fn) {
				var newArr = [];
				arr.forEach(function (value, i, context) {
					Array.prototype.push.apply(newArr, fn(value, i, context));
				});
				return newArr;
			}
			function mapManyObj(obj, fn) {
				var newObj = {};
				forEach(obj, function (value, key, context) {
					extend(newObj, fn(value, key, context));
				});
				return newObj;
			}
			function map(target, fn) {
				if (Array.isArray(target)) {
					return target.map(function () {
						return fn.apply(this, arguments);
					});
				}
				else {
					var newObj = {};
					forEach(target, function (value, key, context) {
						newObj[key] = fn(value, key, context);
					});
					return newObj;
				}
			}
			function filter(target, fn) {
				if (Array.isArray(target)) {
					return target.filter(fn);
				}
				else {
					var newObj = {};
					forEach(target, function (value, key, context) {
						if (fn(value, key, context)) {
							newObj[key] = value;
						}
					});
					return newObj;
				}
			}
			function forEach(obj, fn) {
				if (Array.isArray(obj)) {
					return Array.forEach(obj, fn);
				}
				else {
					for (var prop in obj) {
						if (!Object.hasOwnProperty.call(obj, prop)) {
							continue;
						}
						fn(obj[prop], prop, obj);
					}
				}
			}
			function extend(target, source) {
				if ((isObject(target) || isFunction(target)) && isObject(source)) {
					for (var prop in source) {
						if (!Object.hasOwnProperty.call(source, prop)) {
							continue;
						}
						target[prop] = source[prop];
					}
				}
				return target;
			}
			function isFunction(value) { return typeof value === 'function'; }
			function shallowCopy(target) {
				var newObj;
				if (Array.isArray(target)) {
					return extend([], target);
				}
				else if (isObject(target)) {
					return extend({}, target);
				}
				else {
					return target;
				}
			}
			function isDate(value) {
				return Object.prototype.toString.call(value) === '[object Date]';
			}
			return extend(sdcRecordSetFactory.bind(null, false), {
				grouped: sdcRecordSetFactory.bind(null, true)
			});
		}
	}
});
